import { httpClient } from '@/configs/axios.config'
import type {
  ActiveSendBatches,
  RetrySendBatch,
  SendBatchDetail,
  SendBatchEnqueue,
  SendBatchPreview,
  SendBatchRequest,
} from '@/types/api'

export async function previewSendBatch(
  body: SendBatchRequest
): Promise<SendBatchPreview> {
  const response = await httpClient.post<SendBatchPreview>(
    '/deal-send-batches/preview',
    body,
    // The confirm dialog shows the error inline.
    { skipErrorToast: true }
  )
  return response.data
}

export async function enqueueSendBatch(
  body: SendBatchRequest
): Promise<SendBatchEnqueue> {
  const response = await httpClient.post<SendBatchEnqueue>(
    '/deal-send-batches',
    body,
    // The confirm dialog toasts its own message.
    { skipErrorToast: true }
  )
  return response.data
}

export async function retrySendBatch(
  id: string,
  body: RetrySendBatch
): Promise<SendBatchEnqueue> {
  const response = await httpClient.post<SendBatchEnqueue>(
    `/deal-send-batches/${id}/retry`,
    body,
    // The status pill toasts its own message.
    { skipErrorToast: true }
  )
  return response.data
}

export async function getActiveSendBatches(): Promise<ActiveSendBatches> {
  const response = await httpClient.get<ActiveSendBatches>(
    '/deal-send-batches/active',
    // Polled every 2.5 s; the pill shows a failure as "not updating".
    { skipErrorToast: true }
  )
  return response.data
}

export async function getSendBatch(id: string): Promise<SendBatchDetail> {
  const response = await httpClient.get<SendBatchDetail>(
    `/deal-send-batches/${id}`,
    // Polled while the status popover is open; the popover shows it as missing.
    { skipErrorToast: true }
  )
  return response.data
}
